:host {
  display: inline-block;
}

svg {
  display: block;
} 